import React from 'react';
import styled from 'styled-components';
import { fontUbuntuLight } from '../../utilities/utilities';


const FlexItem = styled.div`
    flex: 1 1 auto;
    text-align: ${ props => props.right ? 'right' : 'left' };
    margin-bottom: 1rem;
`

const TermsSpan = styled.span`
    display: block;
    color: ${props => props.textColor ? props.textColor : '#0d1b58'};
    font-size: 1.0625em;
    font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
    font-weight: ${ props => props.bold ? 700 : 500 };
`;
const FlexboxList = (props) => {
    let TermItem = Object.keys(props.list.terms).map((element, index) => {

            return <FlexItem>{Object.keys(props.list.terms[element]).map((flexTerm, index) =>{
            return <TermsSpan bold = {props.list.terms[element][flexTerm].style} fontFamily={props.appState.ui.terms.card.fontFamily} textColor={props.appState.ui.terms.card.titleTextColor}>{props.list.terms[element][flexTerm].text}</TermsSpan>
            })}</FlexItem>

    });

    return (<div>{TermItem}</div>

)

}

export default FlexboxList;


// WEBPACK FOOTER //
// ./src/components/Lists/FlexboxList.js